<template>
  <div>
    <ThePageHeader :title="'Jogi nyilatkozat'" />

    <div class="mt-5 maximize">
      <p class="subheading">
        A print-pack.hu üzemeltetője:
      </p>

      <p>
        Körös PRINT-PACK Nyomdaipari Csomagolástechnikai Kft.<br>
        Cím: H-5600 Békéscsaba, Orosházi út 32.<br>
        Adószám: 10264175-2-04<br>
        Telefon: +3666447608<br>
        E-mail: info@print-pack.hu
      </p>

      <p>
        A print-pack.hu-n, illetve aldomainjein található információk minden esetben
        tájékoztató, illetve illusztrációs jellegűek, eltérhetnek a valóságtól.
        A felmerülő hibákért, tévedésekért, elavult információkért nem vállalunk
        felelősséget. A Körös PRINT-PACK Kft. fenntartja a jogot az oldal figyelmeztetés
        nélküli módosítására, törlésére. A Körös PRINT-PACK Kft. nem vállal felelősséget
        a print-pack.hu-n található linkeken keresztül elérhető bármely külső tartalomért.
      </p>

      <p>
        A print-pack.hu kereskedelmi, illetve egyéb üzleti célú mentése, sokszorosítása, illetve
        terjesztése szigorúan tilos. A print-pack.hu-n található képi és szöveges tartalmak
        szerzői jogvédelem alatt állnak.
      </p>

      <p>
        A print-pack.hu látogatója a weboldal használatával a fenti feltételeket elfogadja.
      </p>

      <p>
        Észrevételeket az info@print-pack.hu címen fogadunk.
      </p>
    </div>
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';

export default {
  name: 'LegalNotice',
  components: {
    ThePageHeader,
  },
  metaInfo: {
    title: 'Jogi nyilatkozat | Körös PRINT-PACK Kft.',
  },
};
</script>
